/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { OnInit, Directive } from '@angular/core';

import { PageService } from '../services/page.service';

import { UnsubscriberClass } from './unsubscriber.class';


@Directive()
export abstract class PageBaseClass extends UnsubscriberClass implements OnInit {

	constructor(protected pageService: PageService) {
		super();
	}

	ngOnInit() {
		// keep me
	}
}
